import KickoutLayout from "../Layout/KickoutLayout";
import { useEffect, useState } from "react";

export default function SessionExpired() {
    const [isPreOnboarding, setIsPreOnboarding] = useState(false);

    useEffect(() => {
        const previousPageUrl = document.referrer;
        const lastSegment = previousPageUrl.split('/').filter(Boolean).pop() ?? '';
        const isPreOnboarding = lastSegment === 'pre-onboarding' || lastSegment.startsWith('pre-onboarding-');
        setIsPreOnboarding(isPreOnboarding);
    }, []);

    return (
        <KickoutLayout
            header="Session Expired"
            icon="icon-alert"
        >
            <div className="container">
                <div className="margin-top row" style={{ marginTop: "60px" }}>
                    <div className="hidden-sm col-md-3">
                        <img src="images/pose.png" alt="Decorative pose" />
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <div className="alert-content" style={{ marginTop: "40px" }}>
                            <p className="h3" style={{ whiteSpace: "nowrap" }}>
                                Your session has expired due to Inactivity.
                            </p>
                            <p>
                                {isPreOnboarding
                                    ? <>Please <a href="/pre-onboarding">return to Create Your Profile</a> and try again.</>
                                    : <>Don't worry, your progress was saved. To pick up where you left off, <a href="/onboarding-recall-search">continue your application</a>.</>
                                }

                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </KickoutLayout>
    );
}